"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["isOccasionHasPassed", "isOccasionWasDeleted", "filledHealthdeclarations", "healthdeclarationTests", "occasionHasActualTime", "bookedTime", "employeeIsInOccasion"],

  data: function data() {
    return {
      notFilledHealthdeclarations: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.notFilledHealthdeclarations = this.healthdeclarationTests.filter(function (test) {
      return !_this.filledHealthdeclarations.map(function (filledTest) {
        return filledTest.type_id;
      }).includes(test.id);
    });
  },


  methods: {
    hasBookedTime: function hasBookedTime() {
      return !!this.bookedTime;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/dashboard/occasions/Status.vue
// module id = N6Ee
// module chunks = 1